import * as React from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { CreateDto } from '../../config/filePartyConfig'
import NaturalPersonForm, { NaturalPersonMutationDto } from '../../components/Form/Party/NaturalPersonForm'
import { AddPartyProps, PartyStatus } from '../../components/Form/Party/PartyForm'
import useAxios from '../../hooks/useAxios'
import useAttributes, { AttributeContextType, AttributeViewType, EntityAttributeType } from '../../hooks/useAttributes'

export const getPartyOverviewUrl = (fileId?: string) => {
    return fileId ? `/file/${fileId}/party` : '/party'
}

export default function AddNaturalPerson() {
    const axios = useAxios()
    const history = useHistory<{ reload: boolean }>()

    const attributes = useAttributes(AttributeViewType.Input, [AttributeContextType.NaturalPerson], undefined, EntityAttributeType.Party)
    const { fileId } = useParams<{ fileId?: string }>()
    const location = useLocation()

    const initialValues = {
        name: {
            initials: '',
            first: '',
            given: '',
            insertion: null,
            last: '',
        },
        addressCountry: 'NL',
        status: PartyStatus.Active,
    } as NaturalPersonMutationDto

    attributes.applyDefaultValues(initialValues)

    return (
        <NaturalPersonForm
            formikProps={{
                initialValues,
            }}
            onSubmit={(party: NaturalPersonMutationDto) =>
                axios.post<string>('/party/natural', {
                    ...party,
                    pivot: fileId ? ({ fileId, ...((location.state as AddPartyProps) || {}) } as CreateDto) : undefined,
                })
            }
            goBack={() => history.goBack()}
            attributes={attributes}
        />
    )
}
